import React from "react";
import { Modal, Button, Form } from "react-bootstrap";
import "./ProfileSummary.css";

const ProfileSummary = ({
  show,
  handleClose,
  openChooseOption,
  summary,
  setSummary,
}) => {
  const maxLength = 4000;

  const handleSave = () => {
    console.log(summary);
    handleClose();
  };

  return (
    <Modal
      show={show}
      onHide={handleClose}
      centered
      size="lg"
      dialogClassName="common-modal profile-summary-modal"
    >
      <Modal.Header className="profile-summary-header">
        <Modal.Title>Profile summary</Modal.Title>

        <div
          className="view-options"
          onClick={openChooseOption}
          style={{ cursor: "pointer" }}
        >
          View Options
        </div>

        <button className="btn-close" onClick={handleClose}></button>
      </Modal.Header>

      <Modal.Body className="profile-summary-body">
        <div className="ai-limit-box">
          AI generation limit reached for the month
        </div>

        <Form.Group>
          <Form.Control
            as="textarea"
            rows={7}
            value={summary}
            maxLength={maxLength}
            onChange={(e) => setSummary(e.target.value)}
            className="summary-textarea"
          />
        </Form.Group>

        <div className="character-count">
          Max. {summary.length}/{maxLength} character
        </div>
      </Modal.Body>

      <Modal.Footer className="we-modal-footer">
        <Button variant="primary" className="we-btn-save" onClick={handleSave}>
          Save
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ProfileSummary;
